import { buildParams } from '@/helpers/url';

const actions = {
  async getSubordinateList(context, params) {
    try {
      const queries = buildParams(params);
      const url = `${this._vm.$endPoint}/employee-dashboard/list-subordinates-pagination?`;
      const { data, status, statusMessage, response } = await this._vm.$axios.get(url + queries);

      if (status === 200) {
        const contents = data.contents || {};
        return {
          data: contents.data || [],
          total: contents.total,
          current_page: contents.current_page,
          last_page: contents.last_page,
        };
      }

      throw response?.data?.message || statusMessage;
    } catch (err) {
      throw Error(err);
    }
  },
  async getReviewFeedbackFilter(context, params) {
    try {
      const queries = buildParams(params);
      const url = `${this._vm.$endPoint}/employee-dashboard/dropdown-review-feedback?`;
      const { data, status, statusMessage, response } = await this._vm.$axios.get(url + queries);

      /* eslint-disable camelcase */
      if (status === 200 && data?.content?.dropdown_cycle) {
        if (data?.content?.dropdown_cycle.length) {
          const filters = data.content?.dropdown_cycle.map(cycle => ({
            id: cycle.uuid,
            content: cycle.name,
            children: cycle.cycles.map(period => ({ id: period.uuid, content: period.period })),
          }));
          /* eslint-enable camelcase */
          return { filters: JSON.parse(JSON.stringify(filters)), selected: filters[0].children[0] };
        }
        return { filters: [], selected: {} };
      }

      throw response?.data?.message || statusMessage;
    } catch (err) {
      throw Error(err);
    }
  },
  async getReviewFeedbacks(context, params) {
    try {
      const queries = buildParams(params);
      const url = `${this._vm.$endPoint}/employee-dashboard/review-feedback?`;
      const { data, status, statusMessage, response } = await this._vm.$axios.get(url + queries);

      if (status === 200 && data?.content) return data.content;

      throw response?.data?.message || statusMessage;
    } catch (err) {
      throw Error(err);
    }
  },
  async getEmployeeList(context, params) {
    try {
      const queries = buildParams(params);
      const url = `${this._vm.$endPoint}/users/employee-list?`;
      const { data, status, statusMessage, response } = await this._vm.$axios.get(url + queries);

      if (status === 200 && data?.contents) return data.contents;

      throw response?.data?.message || statusMessage;
    } catch (err) {
      throw Error(err);
    }
  },
};

export default {
  namespaced: true,
  actions,
};
